import { IPageParam } from '@core/main/types';

/** 来账账户分页查询请求参数 */
export interface IAlipayUnitBankAccountRequest extends IPageParam {
  /** 服务商id */
  serverId: string;
  /** 企业名称 */
  companyName?: string;
  /** 企业编号 */
  companyNo?: string;
  /** 账户 */
  unitNo?: string;
  /** 来账银行账号 */
  bankAccount?: string;
  /** 账户状态 1：报备中|2：报备通过|3：报备驳回 */
  accountStatus?: EAlipayBankReportStatus;
  /** 排序字段 */
  sortingFields?: string;
}

/** 来账账户分页数据项 */
export interface IAlipayUnitBankAccountDetail {
  /** 账户ID */
  id: number;
  /** 子单元编号 */
  unitNo: string;
  /** 关联企业名称 */
  companyName: string;
  /** 关联企业编号 */
  companyNo: string;
  /** 来账企业名 */
  rechargeCompanyName: string;
  /** 来账银行名称 */
  bankName: string;
  /** 来账银行账号 */
  bankAccount: string;
  /** 账户状态：0:待审核|1：报备中|2：报备通过|3：报备驳回 */
  accountStatus: EAlipayBankReportStatus;
  /** 账户状态文本 */
  accountStatusText: string;
  /** 备注 */
  remark: string;
  /** 创建时间 */
  createTime: string;
}

/** 来账账户分页数据 */
export interface IAlipayUnitBankAccountPage {
  /** 数据列表 */
  data: IAlipayUnitBankAccountDetail[];
  /** 总数 */
  total: number;
}

/** 来账账户分页查询响应 */
export interface IAlipayUnitBankAccountResponse {
  /** 返回状态码 */
  code: number;
  /** 返回信息 */
  message: string;
  /** 返回业务数据 */
  context: IAlipayUnitBankAccountPage;
  /** 链路追踪id */
  traceId: string;
  /** 链路追踪spanId */
  spanId: string;
}

/** 新增来账账户请求参数 */
export interface IAlipayUnitBankAccountAddRequest {
  /** 子单元编号 */
  unitNo: string;
  /** 企业名称 */
  companyName: string;
  /** 银行名称 */
  bankName: string;
  /** 银行账号 */
  bankAccount: string;
  /** 备注 */
  remark?: string;
}

export interface IAlipayUnitBankAccountUpdateParam {
  /** 账户ID */
  idList: number[];
  /** 状态 */
  status: EAlipayBankReportStatus;
  /** 备注 */
  remark?: string;
}

/** 支付宝记账簿分页查询请求参数 */
export interface IAlipayUnitPageRequest extends IPageParam {
  /** 服务商id */
  serverId?: string;
  /** 企业名称 */
  companyName?: string;
  /** 企业编号 */
  companyNo?: string;
  /** 账户 */
  unitNo?: string;
  /** 来账银行账号 */
  bankAccount?: string;
  /** 账户状态 1：报备中|2：报备通过|3：报备驳回 */
  accountStatus?: EAlipayBankReportStatus;
  /** 排序字段 */
  sortingFields?: string;
}

/** 支付宝记账簿账户信息 */
export interface IAlipayUnitBankAccount {
  /** 账户ID */
  id: number;
  /** 子单元编号 */
  unitNo: string;
  /** 关联企业名称 */
  companyName: string;
  /** 关联企业编号 */
  companyNo: string;
  /** 来账企业名 */
  rechargeCompanyName: string;
  /** 来账银行名称 */
  bankName: string;
  /** 来账银行账号 */
  bankAccount: string;
  /** 账户状态：0:待审核|1：报备中|2：报备通过|3：报备驳回 */
  accountStatus: EAlipayBankReportStatus;
  /** 账户状态文本 */
  accountStatusText: string;
  /** 备注 */
  remark: string;
  /** 创建时间 */
  createTime: string;
}

/** 支付宝记账簿分页数据项 */
export interface IAlipayUnitDetail {
  /** ID */
  id: number;
  /** 账户 */
  unitNo: string;
  /** 企业名称 */
  companyName: string;
  /** 企业id */
  companyId: number;
  /** 企业编号 */
  companyNo: string;
  /** 可用金额(元) */
  balance: number;
  /** 充值总金额(元) */
  rechargeAmount: number;
  /** 总提现金额(元) */
  withdrawAmount: number;
  /** 总提现服务费 */
  withdrawServiceAmount: number;
  /** 账户列表 */
  accountList: IAlipayUnitBankAccount[];
}

/** 来账账户列表数据项 */
export interface IAlipayUnitBankAccountListItem {
  /** 账户ID */
  id: number;
  /** 子单元编号 */
  unitNo: string;
  /** 关联企业名称 */
  companyName: string;
  /** 关联企业编号 */
  companyNo: string;
  /** 来账企业名 */
  rechargeCompanyName: string;
  /** 来账银行名称 */
  bankName: string;
  /** 来账银行账号 */
  bankAccount: string;
  /** 账户状态：0:待审核|1：报备中|2：报备通过|3：报备驳回 */
  accountStatus: EAlipayBankReportStatus;
  /** 账户状态文本 */
  accountStatusText: string;
  /** 备注 */
  remark: string;
  /** 创建时间 */
  createTime: string;
  /** 驳回原因 */
  rejectReason: string;
}

/** 支付宝记账簿提现请求参数 */
export interface IAlipayUnitWithdrawRequest {
  /** 账户 */
  unitNo: string;
  /** 提现金额 */
  amount: number;
  /** 记账簿银行卡账户id */
  bankAccountId: number;
  /** 支付密码 */
  payPassword: string;
  /** 支付手机号 */
  payPhone: string;
  /** 支付密码 */
  password: string;
  /** 随机因子 */
  randomKey?: string;
  /** 验证码 */
  code: string;
}

export enum EAlipayBankReportStatus {
  /** 报备中 */
  REPORTING = 1,
  /** 通过 */
  PASS = 2,
  /** 驳回 */
  REJECT = 3,
}

export const alipayBankReportStatusLabel = {
  [EAlipayBankReportStatus.REPORTING]: '报备中',
  [EAlipayBankReportStatus.PASS]: '报备成功',
  [EAlipayBankReportStatus.REJECT]: '报备失败',
};

export const alipayBankReportStatusStyle = {
  [EAlipayBankReportStatus.REPORTING]: 'info',
  [EAlipayBankReportStatus.PASS]: 'success',
  [EAlipayBankReportStatus.REJECT]: 'danger',
};

